import Upload from './components/Upload';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'upload',
  pluginComponent: Upload,
});
